import React, { useState } from "react";

const Page21 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left" style={{ paddingTop: '240px', paddingLeft: '150px' }}>        
        <img src="./img/module1/page11.svg" alt="" style={{ width: '90%' }} />
      </div>

      {/* DIREITA */}      
      <div className="moc-right" style={{ paddingTop: '100px' }}>
        <p>Uma mudança precisa ser feita em uma planta. Você já sabe <strong>que o MOC é obrigatório</strong>, entende <strong>qual é o seu papel</strong> e sabe <strong>quem mais precisa ser envolvido.</strong></p>
        <p>Mesmo assim, surge a dúvida: por onde começar? O que vem primeiro: análise, aprovação ou implementação?</p>
        <p>É aí que entra o processo de MOC, definindo o caminho que a mudança deve seguir, da solicitação ao encerramento.</p>
        <p>A partir daqui, vamos acompanhar como esse processo funciona na prática, passo a passo, conforme o procedimento. Vamos lá!</p>
      </div>

      <style>{`

        .container{
          width: 100% !important;
        }

        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA DIREITA */
        .moc-right {
          width: 50%;
          background: #ffffff;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        /* COLUNA ESQUERDA */
        .moc-left {
          width: 50%;
          padding-top: 250px;
          background: #c2c2c2;
          color: #000000;
          padding: 40px;
          box-sizing: border-box;        }

        .moc-left p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* ================= MOBILE ================= */
        @media (max-width: 768px) {

          .moc-page {
            flex-direction: column;
            // height: auto;
          }

          .moc-left,
          .moc-right {
            width: 100%;
            padding: 20px;
          }

          .moc-left {
            padding-top: 100px !important;
          }

          .moc-right {
            padding-top: 0px !important;
          }

          .moc-right img {
            width: 100%;
            max-width: 300px;
          }

        }

      `}</style>
    </div>
  );
};

export default Page21;